/**
 * Funzioni API per la Danger Zone del pannello Admin (product-service).
 *
 * Endpoint:
 *   DELETE /api/products/admin/catalog   → { deleted, triagesDeleted } (solo SYSTEM_CONFIGURATION)
 */

import { createServiceClient } from '../../api/client.js';

const productApi = createServiceClient('product');

export interface DeleteCatalogResult {
  deleted: number;
  triagesDeleted: number;
}

/**
 * Elimina (soft-delete a cascata) l'intero catalogo prodotti, incluso l'hard-delete dei
 * Ticket collegati. DELETE /api/products/admin/catalog
 */
export function deleteProductCatalog(): Promise<DeleteCatalogResult> {
  return productApi<DeleteCatalogResult>('/admin/catalog', { method: 'DELETE' });
}
